module.exports = __webpack_public_path__ + "static/MELA-217379_ROR-Concept_chart_L18_mobile-64f2f7b069b72027aa56da5e3bdb658e.png";